import dayjs from 'dayjs';

export function years_check(birthDate, minAge = 15, when = dayjs()) {
    const minBirthDate = birthDate.year(birthDate.year() + minAge);
    return when.isAfter(minBirthDate)
}

export function can_register(user) {
    if (user && user.profile) {
        const birthDate = dayjs(user.profile.birth_date, 'YYYY-MM-DD');
        return years_check(birthDate)
    }

    return false;
}